import React from 'react';
import { Form, Alert, Switch, Icon, Button, Row, Col, Checkbox } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Fieldset, Control, track } from 'react-redux-form';

import { updateRequestProperties } from 'modules/userrequest';
import { readUserrequestParkings } from 'modules/userrequestParkings';
import ParkingsMap from 'components/Summary/ParkingsMap';
import CheckboxField from 'components/Fields/Checkbox';
import FormSchema from './FormSchema';
import FormVehiclesLicense from './FormVehiclesLicense';

import './formVehicles.scss';

function getParkingLabel (parking) {
  const { properties: { NAME: name, LV_CPY: capacity } = {} } = parking;
  return `${name} ${capacity ? `(${capacity} pl.)` : ''}`;
}


class FormVehicles extends React.Component {
  constructor (props) {
    super(props);
    this.removeVehicles = this.removeVehicles.bind(this);
    this.addVehicles = this.addVehicles.bind(this);

    props.readUserrequestParkings();
  }

  /**
   * Remove the vehicle by its id
   * @param  {number} k
   */
  removeVehicles (uid) {
    // Close the switch if we delete the last item
    if (this.props.vehicles.licenses.length === 1) {
      return this.props.updateRequestProperties({
        vehicles: {
          ...this.props.vehicles,
          hasVehicles: false,
        },
      });
    }

    return this.props.updateRequestProperties({
      vehicles: {
        ...this.props.vehicles,
        licenses: this.props.vehicles.licenses.filter(license => license.uid !== uid),
      },
    });
  }

  /**
   * Add and init a new Vehicle
   */
  addVehicles () {
    const keys = this.props.vehicles.licenses.map(license => license.uid);
    const uid = Math.max(...keys) + 1;

    this.props.updateRequestProperties({
      vehicles: {
        ...this.props.vehicles,
        licenses: [
          ...this.props.vehicles.licenses,
          { name: '', owner: '', comment: '', uid },
        ],
      },
    });
  }

  render () {
    const { parkings, savedParkings = [], vehicles: { hasVehicles, licenses } = {} } = this.props;
    const options = parkings.map(parking => ({
      value: savedParkings.find(p => p.properties.id === parking.properties.id) || parking,
      label: getParkingLabel(parking),
    }));
    options.sort((a, b) => {
      const labelA = a.label.toLowerCase();
      const labelB = b.label.toLowerCase();
      if (labelA > labelB) return 1;
      if (labelA < labelB) return -1;
      return 0;
    });

    return (
      <React.Fragment>
        <Fieldset model=".properties">
          <h3>Stationnement</h3>
          <ParkingsMap
            zoom={[7]}
            center={[2.62322, 48.40813]}
            maxBounds={[[1.509247, 48.143182], [4.036102, 49.036968]]}
          />
          <div className="parkings">
            <Row
              gutter={16}
              className="parkings__list parkings-list"
            >
              {parkings.length && (
                <CheckboxField
                  model=".parkings"
                  label=""
                  type="checkbox"
                  options={options}
                  renderItem={({ value, label }) => (
                    <Col
                      key={value.properties.id}
                      span={8}
                    >
                      <label>
                        <Checkbox
                          value={value}
                          className="parkings-list__input"
                        />
                        {label}
                      </label>
                    </Col>
                  )}
                />
              )}
            </Row>
          </div>

          <h3>Véhicule(s)</h3>
          <Control
            model=".vehicles.hasVehicles"
            component={innerProps => (
              <Form.Item label={FormSchema.vehicles.yesOrNo.label}>
                <Switch
                  checked={hasVehicles}
                  checkedChildren={<Icon type="check" />}
                  unCheckedChildren={<Icon type="close" />}
                  onChange={innerProps.onChange}
                />
              </Form.Item>
            )
            }
          />

          {hasVehicles && (
            <div>
              {licenses.map(license => (
                <Fieldset model={track('.vehicles.licenses[]', item => item.uid === license.uid)} key={license.uid}>
                  <FormVehiclesLicense
                    license={license}
                    {...this.props}
                    removeVehicles={this.removeVehicles}
                  />
                </Fieldset>
              ))}

              <Button type="dashed" onClick={this.addVehicles} style={{ margin: '24px auto' }}>
                <Icon type="plus" /> {FormSchema.vehicles.add}
              </Button>

              <Alert
                style={{ margin: '0 0 24px' }}
                message="Commande des macarons"
                description={FormSchema.vehicles.message}
                type="warning"
                showIcon
              />
            </div>
          )}
        </Fieldset>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  savedParkings: state.userrequest.properties.parkings || [],
  vehicles: state.userrequest.properties.vehicles,
  parkings: state.userrequestParkings.parkings,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ updateRequestProperties, readUserrequestParkings }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FormVehicles);



// WEBPACK FOOTER //
// ./src/components/Form/FormVehicles.js